/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactSaveRequest {
    getFixupPrototypeFunction() { return ArtifactSaveRequest.fixupPrototype; }

    static newInstance(model: Partial<ArtifactSaveRequest>): ArtifactSaveRequest {
        let obj = Object.assign(new ArtifactSaveRequest(), model);
        ArtifactSaveRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactSaveRequest>): ArtifactSaveRequest {
        if (!model) return null;
        return ArtifactSaveRequest.newInstance(<ArtifactSaveRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactSaveRequest) {
        if (!obj) return;

        models.ArtifactSaveRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactSaveRequest): boolean {
        Object.setPrototypeOf(obj, ArtifactSaveRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Title of the artifact
     */
    title: string;

    /**
     * Description of the artifact
     */
    description: string;

    /**
     * ID of the agent the artifact was generated from
     */
    agent_id: string;

    /**
     * ID of the chat the artifact was saved from
     */
    source_chat_id: string;

    /**
     * ID of the conversation turn the artifact was saved from
     */
    source_conversation_id: string;

    /**
     * Kind of artifact
     */
    kind: models.ArtifactKind;

    /**
     * Rendered HTML content of the artifact
     */
    html_content: string;

    /**
     * Original prompt used to generate the artifact, for deterministic regeneration
     */
    source_prompt: string;

    /**
     * Original execution parameters used to generate the artifact, for deterministic regeneration
     */
    source_params: any;

    /**
     * Tags for search/organization
     */
    tags: Array<string>;

}
